import React from 'react';
import { IndexRedirect, Route } from 'react-router';
import privateRoute from 'containers/Credit24/SelfService/PrivateRouteContainer';
import Application from 'containers/Credit24/SelfService/Application';
import LoginContainer from 'containers/Credit24/SelfService/LoginAUContainer';
import RequestPasswordResetContainer from 'containers/Credit24/LoanApplication/RequestPasswordResetAUContainer';
import DashboardContainer from 'containers/Credit24/SelfService/DashboardContainer';
import CreditInformationTitleContainer from 'containers/Credit24/SelfService/CreditInformationTitleContainer';
import CreditInformationContainer from 'containers/Credit24/SelfService/CreditInformationContainer';
import TransactionsContainer from 'containers/Credit24/SelfService/TransactionsContainer';
import InvoicesContainer from 'containers/Credit24/SelfService/InvoicesContainer';
import ChangeCreditLineContainer from 'containers/Credit24/SelfService/ChangeCreditLineContainer';
import StatementOfAccountContainer from 'containers/Credit24/SelfService/StatementOfAccountContainer';
import CreditApplicationStateContainer from 'containers/Credit24/SelfService/CreditApplicationStateContainer';
import CustomerMigrationAUContainer from 'containers/Credit24/Common/CustomerMigrationAUContainer';

export default () => (
  <Route path="/" component={Application}>
    <IndexRedirect to="/dashboard" />
    <Route path="/login" component={LoginContainer} />
    <Route path="/password-reset" component={RequestPasswordResetContainer} />
    <Route
      path="/dashboard"
      component={privateRoute(DashboardContainer)}
    />
    <Route
      path="/credit-information"
      component={privateRoute(CreditInformationContainer, CreditInformationTitleContainer)}
    />
    <Route
      path="/repayment-info"
      component={privateRoute(InvoicesContainer, 'selfservice.repaymentInfo.title')}
    />
    <Route
      path="/transactions"
      component={privateRoute(TransactionsContainer, 'selfservice.transactions.title')}
    />
    <Route
      path="/upgrade"
      component={privateRoute(ChangeCreditLineContainer, null, 'CUSTOM')}
    />
    <Route
      path="/statement-of-account"
      component={privateRoute(StatementOfAccountContainer, 'selfservice.statementOfAccount.title')}
    />
    <Route
      path="/status"
      component={privateRoute(CreditApplicationStateContainer, null, 'WHOLE')}
    />
    <Route
      path="/welcome"
      component={privateRoute(CustomerMigrationAUContainer, null, 'CUSTOM')}
    />
  </Route>
);
